import { Link } from 'react-router-dom';
import AnimatedImage from '../components/AnimatedImage/AnimatedImage';
import projects from '../assets/json/projects.json';

const Projects = () => {
    return (
        <main className="flex-column medium-gap">
            <h2>My Greatest Hits</h2>
            <div className="flex-row flex-wrap medium-gap">
                {Object.entries(projects).map(([key, project]) => {
                    return (
                        <Link key={key} to={`/projects/${key}`} className="project align-start flex-column small-gap">
                            <AnimatedImage alt={project.title} src={require(`../assets/images/${key}.webp`)} />
                            <p className="text-caption">{project.type}</p>
                            <h3>{project.longTitle}</h3>
                        </Link>
                    );
                })}
            </div>
        </main>
    )
}

export default Projects;